// extracted by mini-css-extract-plugin
export default {"panel":"TabPanel__panel___ppvMc","hidden":"TabPanel__hidden___rPKZX"};